import React, { Component } from "react";
import { connect } from "react-redux";
import {bindActionCreators} from 'redux';
import comments from '../../../images/space/comment_active.svg';
import * as familyspaceActions from '../../../actions/familySpaceActions';
import {isSmartphone} from "../../../services/domFunctions";
// import commentIcon from "../../../images/icons-config-famille/comment-icon-gpg-granit.svg"

 class ScommentsComponent extends Component {
  state={hover:false,choice:false}
 
  commentText = (data)=>{
    let text = data.name ? data.name: "???";
    text += `: ${data.comment.text}`;
    return text
   }
   addComment = ()=>{
    if (isSmartphone()){

      const elem = document.body.querySelector(".listProjects");
      elem.scrollTop += 67;
    }
    this.props.addComment();
    this.props.markAllAsRead();
   }
   hover =(value)=>{
    if (!isSmartphone()){this.setState({hover:value})}
   }
   unreadedComment = () =>{
    const comments = this.props.project.comments;
    let bUnreaded = false;
    const commentsLength = comments.length-1
     const read_by =comments[commentsLength] && comments[commentsLength].read_by ? comments[commentsLength].read_by.filter(item => item.id === this.props.familyService.user.id): [];
     if(comments && comments.length > 0 && read_by && read_by.length === 0){bUnreaded=true;}
     return bUnreaded;
   }

  render() {
    const {project} = this.props;
    const {mainColor} = this.props.adminConfig.config
    const commentIcon = `<svg id="Calque_9" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400"><defs><style>.svg-comments{fill:${mainColor && mainColor};}</style></defs><path class="svg-comments" d="m335.8,24.71c-47.46-.07-93.28-.1-138.08-.1s-89.01.03-132.62.1c-30.85.05-56.02,25.22-56.11,56.11-.17,61.45-.29,116.87.08,172.78.14,20.87,9.73,37.19,28.51,48.52,7.93,4.78,17.24,7.3,28.45,7.7l4.19.15.02,20.14c.02,12.72.04,25.87.12,38.8,0,1.48.09,3.63.7,5.28.93,2.53,2.8,4.21,5.27,4.72,2.87.59,6.02-.53,8.39-3.02,21.52-22.57,40.79-42.89,58.9-62.13,2.68-2.85,5.69-4.12,9.76-4.12h.02c70.78.08,128.37.09,181.23.03,26.64-.03,48.95-17.28,55.51-42.92.45-1.76.84-3.51,1.26-5.37.16-.71.32-1.43.48-2.14V75.41c-.23-.58-.51-1.35-.65-2.26-4.08-27.57-27.92-48.4-55.45-48.44Zm40.3,226.12c0,25.76-17.4,43.07-43.28,43.07h-29.34c-51.29.02-104.33.03-156.49-.07h-.04c-4.44,0-7.49,1.33-10.53,4.59-9.84,10.57-19.96,21.2-29.75,31.48-3.41,3.58-6.83,7.17-10.24,10.76-.53.56-1.05,1.04-1.77,1.7-.37.34-.8.74-1.33,1.24l-7.33,6.92v-10.08c0-3.2-.03-6.29-.06-9.32-.06-6.54-.12-12.72.12-18.96.36-9.34-.3-13.98-2.28-15.98-1.96-1.99-6.58-2.7-15.95-2.45-6.34.17-12.78-1.03-18.16-3.37-16.28-7.09-24.9-20.46-24.93-38.66-.07-55.82-.04-112.57,0-167.46v-1.55c0-2.77.24-5.57.7-8.31,3.25-19.22,19.69-33.47,39.09-33.86,7.92-.16,15.94-.13,23.71-.1,3.22.01,6.43.03,9.64.03h53.8c60.7,0,121.41-.01,182.11.01,21.78,0,38.62,14.38,41.91,35.77.37,2.41.37,4.74.37,6.99v.15c.02,55.82.02,111.65,0,167.47Z"/><path class="svg-comments" d="m106.86,167.11c-.01,5.38,2.08,10.45,5.9,14.27,3.81,3.82,8.86,5.92,14.22,5.92h.01c5.37,0,10.42-2.11,14.22-5.93,3.81-3.83,5.9-8.91,5.88-14.29-.02-5.35-2.14-10.39-5.96-14.17-3.81-3.77-8.85-5.84-14.2-5.84-.05,0-.09,0-.14,0-10.97.07-19.91,9.07-19.93,20.05Z"/><path class="svg-comments" d="m200.42,147.05h0c-10.99,0-20.02,8.91-20.12,19.87-.05,5.41,2.02,10.51,5.82,14.38,3.77,3.83,8.79,5.96,14.13,6,.04,0,.09,0,.13,0,5.34,0,10.38-2.08,14.19-5.85,3.83-3.79,5.95-8.83,5.96-14.18h0c.02-5.39-2.07-10.46-5.88-14.28-3.8-3.82-8.86-5.92-14.23-5.92Z"/><path class="svg-comments" d="m273.95,147.05h-.08c-5.35,0-10.4,2.09-14.21,5.88-3.82,3.8-5.93,8.86-5.93,14.22,0,5.37,2.1,10.43,5.92,14.24,3.81,3.8,8.86,5.9,14.21,5.9h.05c5.36-.01,10.4-2.13,14.19-5.95,3.81-3.84,5.89-8.92,5.86-14.32-.06-10.97-9.04-19.93-20.02-19.97Z"/></svg>`
    return(
        <div className="Scomments" onClick={()=>this.addComment()}
        onMouseEnter={()=>this.hover(true)} onMouseLeave={()=>this.hover(false)} >
          <span dangerouslySetInnerHTML={{ __html: commentIcon }} />
          {/* <img  src={commentIcon} alt="Commentaires" style={{"height": "25px"}} /> */}
          {/* <svg id="Capa_1" enableBackground="new 0 0 511.096 511.096" height="512" viewBox="0 0 511.096 511.096" width="512" xmlns="http://www.w3.org/2000/svg"><g id="Speech_Bubble_48_"><g><path d="m74.414 480.548h-36.214l25.607-25.607c13.807-13.807 22.429-31.765 24.747-51.246-59.127-38.802-88.554-95.014-88.554-153.944 0-108.719 99.923-219.203 256.414-219.203 165.785 0 254.682 101.666 254.682 209.678 0 108.724-89.836 210.322-254.682 210.322-28.877 0-59.01-3.855-85.913-10.928-25.467 26.121-59.973 40.928-96.087 40.928z"/></g></g></svg> */}
          <span>{project.comments ? project.comments.length: 0}</span>
          {this.unreadedComment() && <div className="unreadBull">
            -
          </div>}
        </div>
      )
  }
}

export const Scomments = connect(
  state => ({
    familyService:state.familyService,
    adminConfig: state.adminConfig
  }),
  dispatch =>({familyspaceActions: bindActionCreators(familyspaceActions, dispatch)})
)(ScommentsComponent);

